import { LoginForm as LoginFormProps } from '@web/graphql-components'
import { LoginFormStep, LoginForm as PageLoginForm } from '@web/components/page-components/LoginForm'
import SubComponent from './SubComponent'
import { useMutation, useMutationState } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { usePageStore } from 'apps/fe-donation/libs/hooks/usePageStore'
import { useHttpClient } from 'apps/fe-donation/libs/hooks/useHttpClient'

const LoginForm = (props: LoginFormProps) => {
  const charityId = usePageStore((state) => state.charityId)
  const campaignId = usePageStore((state) => state.campaignId)
  const [step, setStep] = useState(LoginFormStep.Login)
  const [error, setError] = useState('')
  const httpClient = useHttpClient({ isRelativeUrl: true })
  const { mutateAsync: loginProfile, isPending } = useMutation({
    mutationFn: (email: string) =>
      httpClient('/api/profile/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, charityId, campaignId }),
      }),
    onSuccess: () => {
      setStep(LoginFormStep.SentEmail)
    },
    onError: (e) => {
      setError('Email not found')
    },
  })

  const [authenticateProfile] = useMutationState({
    filters: { mutationKey: ['authenticateProfile'] },
  })

  useEffect(() => {
    if (!authenticateProfile) {
      return
    }
    const { status } = authenticateProfile

    if (status === 'success') {
      return
    }
    if (status === 'pending') {
      setStep(LoginFormStep.Authenticating)

      return
    }

    setError('Invalid email link')
    setStep(LoginFormStep.Login)
  }, [authenticateProfile])

  return (
    <PageLoginForm
      {...props}
      step={step}
      error={error}
      SubComponent={SubComponent}
      loading={isPending}
      onSubmit={(e) => {
        const formData = new FormData(e.target as HTMLFormElement)

        loginProfile(formData.get('email') as string)
      }}
    />
  )
}

export default LoginForm
